import conversationFlow from './conversationFlow';

class ActionProvider {
  constructor(createChatBotMessage, setStateFunc) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
    this.currentNode = 'initial';
    this.handleOptionClick = this.handleOptionClick.bind(this);
    this.showOptions = this.showOptions.bind(this);
  }

  handleUserMessage(message) {
    // Since we're using predefined options, we don't need to process text input
    console.log("User message:", message);
    const botMessage = this.createChatBotMessage("Please select one of the options below.", {
      withAvatar: true
    });
    this.setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));
  }

  showOptions(nodeId) {
    
    const node = conversationFlow[nodeId];
    if (!node) return;

    if (node.response) {
      // This is a final response node
      const botMessage = this.createChatBotMessage(node.response);
      this.setState((prev) => ({
        ...prev,
        messages: [...prev.messages, botMessage],
      }));
      // Reset to initial state after showing final response
      this.showInitialOptions();
    } else {
      // This is an options node
      const botMessage = this.createChatBotMessage(
        node.question,
        {
          widget: 'options',
          payload: {
            options: node.options,
          }
        }
      );

      this.setState((prev) => ({
        ...prev,
        messages: [...prev.messages, botMessage],
      }));
    }
  }

  handleOptionClick(option) {
    const nextNodeId = option.nextId;
    this.showOptions(nextNodeId);
  }

  showInitialOptions() {
    this.currentNode = 'initial';
    this.showOptions('initial');
  }
}

export default ActionProvider;
